import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {StandardPage} from "../../Common/pages/StandardPage";
import {RightColumn} from "../../Common/pages/RightColumn";

export default class FootballLeagues extends Component {
  static propTypes = {
    FootballLeaguesContainer: PropTypes.element.isRequired,
    location: PropTypes.object.isRequired,
  };

  render() {
    const {
      location,
      FootballLeaguesContainer
    } = this.props;

    return (
      <div className="footballLeagues">
        <StandardPage sport="football" title="football-leagues" >
          <div className="main-layout-left-column">
            {FootballLeaguesContainer}
          </div>

          <RightColumn location={location}
                       sport="football"
                       content={["topMpu"]} />
        </StandardPage>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballLeagues.js